import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';

/**
 * AppShell — common layout for every authenticated console route.
 * Sidebar (fixed width) on the left, scrollable main area on the right.
 * The matched child route renders into `<Outlet />`.
 */
export function AppShell() {
  return (
    <div className="flex h-screen w-screen bg-[var(--ui-bg-paper,#FFFFFF)]">
      <Sidebar />
      {/* No padding here — each page owns its own padding so full-bleed
       *  layouts (e.g. Theme Editor) can extend edge-to-edge. */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
